import { useContext } from "react";
import NonIdealNew from "../../common/NonIdealNew";
import { LanguageContext } from "../../../context/LanguageContext";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { InnerWrapper, MainContainer, TitleAndActionBox } from "../../common";
import { UBButton } from "../../../Libraries";
import withObservables from "@nozbe/with-observables";
import { observePurchaseBillByBusinessCount } from "../../../database/helpers/invoice";
import { PlayIcon } from "../../../assets/icons/icon";
import { useAuthContext } from "../../../context/AuthContext";
import SalePurchaseList from "../NewInvoiceBook/InvoiceBookPages/SalePurchaseList";
import { useFiltersHandler } from "../../../hooks/useFilterHandler";

const PurchaseOrders = ({ invoiceListCount }) => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const { business, user } = useAuthContext();
  const location = useLocation();
  const { filters } = useFiltersHandler(undefined, I18n);

  const handleAddPurchaseOrder = () => {
    triggerLogEvent(analytics, "pne_pb");
    navigate("/PurchaseInvoice/Create", {
      state: {
        pathname: location.pathname,
        data: { invoiceCount: invoiceListCount },
      },
    });
  };

  const isNonIdeal = invoiceListCount <= 0;
  return (
    <MainContainer fluid className="quickSalePage">
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: I18n.purchase_order,
            }}
          >
            <UBButton
              onClick={handleAddPurchaseOrder}
              id={"create_purchase_bill"}
              className="ubPrimaryButton fontSize12 fontWeight400 textUppercase marginLeft12"
              title={I18n.create_purchase_order}
            />
          </TitleAndActionBox>
          <InnerWrapper className="innerWrapper newInnerWrapper">
            {isNonIdeal ? (
              <NonIdealNew
                title={I18n.create_purchase_order}
                subtitle={
                  I18n.start_creating_your_fist_purchase_order_with_easy_steps
                }
                button1Title={"create_purchase_order"}
                // button2Title="watch_video"
                onButton1Click={handleAddPurchaseOrder}
                loading={false}
                disabledOne={false}
                disabledTwo={false}
                buttonOneId={"create_purchase_order"}
                buttonTwoId={"watch_video"}
                prefixIconButtonTwo={
                  <PlayIcon width="18px" height="18px" fill="var(--blue500)" />
                }
                video_footer={{
                  title: I18n.create_purchase_order,
                  onClick: handleAddPurchaseOrder,
                }}
                video_url={
                  "https://www.youtube.com/embed/KpMpGauNeDc?si=_xvfwB-A25WKNQO1"
                }
                videoTitle={I18n.create_purchase_order}
                videoSubtitle={
                  I18n.start_creating_your_fist_purchase_order_with_easy_steps
                }
              />
            ) : (
              <SalePurchaseList
                invoiceListCount={invoiceListCount}
                type={"out"}
                business={business}
                user={user}
                filters={filters}
              />
            )}
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

const enhance = withObservables([], () => ({
  invoiceListCount: observePurchaseBillByBusinessCount(
    localStorage.getItem("business_id"),
  ),
}));

export default enhance(PurchaseOrders);
